import { getComponentByPath } from './get-component-by-path.js';

// There are 4 locations in the pageModel where a SEO config can be added
// For content pages it's always in the default "main/seo" path
const seoLocations = [
    'main/seo',
    'main/container/seo',
    'main/top-container/seo',
    'main/bottom-container/seo', 
];
function getPageSeo(pageModel) {
    if (!pageModel) {
        return undefined;
    }
    let seo;
    // Look for the first path we can find that contains a SEO component
    for (const path of seoLocations){
        const comp = getComponentByPath(path, pageModel);
        if (comp === null || comp === void 0 ? void 0 : comp.models) {
            seo = comp.models.seoData;
            break;
        }
    }
    return seo;
}

export { getPageSeo };
//# sourceMappingURL=get-page-seo.js.map
